export default {
  All: 'all',
  Audit: 'audit',
  Price: 'price',
  RangeOfBarcodes: 'rangeOfBarcodes',
  RangeOfBinLocations: 'rangeOfBinLocations',
  ItemsBelowMin: 'itemsBelowMin',
  Custom: 'custom',
}
